module.exports = __webpack_public_path__ + "static/media/help.542a1396.svg";